import styles from '../../Product.module.scss'

import { DiscountProductHeader } from './discount-product-header'
import { DiscountProductMain } from './discount-product-main'
import { DiscountProductTabs } from './discount-product-tabs'

export const DiscountProductPage = () => (
	<section className={`${styles.product} Product`}>
		<DiscountProductHeader />
		<DiscountProductMain />
		<DiscountProductTabs />
	</section>
)
